export default __webpack_public_path__ + "static/media/011-adventure.3e986095.svg";